/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    // Custom open mobile menu items
    if(document.querySelector('.custom-mobile-menu')) {
        let mobileMenuContainer = document.querySelector('.custom-mobile-menu .menu__items');
        let mobileMenuItes = document.querySelectorAll('.custom-mobile-menu .menu__item');
        let mobileMenuItem = document.querySelectorAll('.custom-mobile-menu .menu__item:not(.child) > a');
        let mobileMenuItemLink = document.querySelectorAll('.custom-mobile-menu .menu__item .navlink');
        let mobileMenuItemClose = document.querySelectorAll('.mobile-menu-close');
    
        mobileMenuItem.forEach((item)=>{
            item.addEventListener('click', (e)=>{
                e.preventDefault();

                mobileMenuContainer.classList.remove('is-active');
                mobileMenuItes.forEach((item)=>{
                    item.classList.remove('is-active');
                })

                if(item.classList.contains('is-active')) {
                    item.classList.remove('is-active');
                    item.closest('.menu__items').classList.remove('is-active');
                    item.closest('.menu__item').classList.remove('is-active');
    
                } else {
                    item.classList.add('is-active');
                    item.closest('.menu__items').classList.add('is-active');
                    item.closest('.menu__item').classList.add('is-active');
                }
            })
        })
    
        mobileMenuItemClose.forEach((item)=>{
            item.addEventListener('click', (e)=>{
                mobileMenuContainer.classList.remove('is-active');
                mobileMenuItes.forEach((item)=>{
                    item.classList.remove('is-active');
                })
                mobileMenuItem.forEach((item)=>{
                    item.classList.remove('is-active');
                })
            })
        })
        
    }


    // Anchor functionality for Listing accessories page
    let searchListingPageOptions = document.querySelectorAll('.image-with-text-selector section');
    let sectionAnchor = document.querySelector('.custom-select--search select');

    if (sectionAnchor && searchListingPageOptions) {
        searchListingPageOptions.forEach((item) => {
            let title = item.dataset.title;
            let formattedTitle = item.dataset.formattedtitle;
            if (!title || !formattedTitle) return;
            const option = document.createElement('option');
            option.value = formattedTitle;
            option.textContent = title;
            sectionAnchor.appendChild(option);
        });

        sectionAnchor.addEventListener('change', () => {
            let id = sectionAnchor.value;
            let target;
            if (id) {
                // Update URL hash
                history.replaceState(null, null, `#${id}`);
                target = document.querySelector(`.image-with-text-selector [data-formattedtitle="${id}"]`);
            }
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    }

    // Scroll to section if URL contains a hash
    document.addEventListener('DOMContentLoaded', () => {
        const hash = window.location.hash.substring(1); // Remove the #
        if (hash) {
            const target = document.querySelector(`.image-with-text-selector [data-formattedtitle="${hash}"]`);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // Optional: preselect the dropdown
                if (sectionAnchor) {
                    sectionAnchor.value = hash;
                }
            }
        }
    });


    /*if (document.querySelector('.home-hero-mobile')) {
    window.addEventListener('scroll', function() {
            const block = document.querySelector('.home-hero-mobile');
            const blockItems = document.querySelector('.home-hero-mobile .banner-image__buttons');
            const blockRect = block.getBoundingClientRect();
            if (blockRect.top  <= 0) {
                blockItems.classList.add('is-active');
            } else {
                blockItems.classList.remove('is-active');
            }
        });
    }*/

    if (document.querySelector('.video-wrapper .video-text-link')) {
        const videoButton = document.querySelectorAll('.video-wrapper .video-text-link');
        videoButton.forEach((item)=>{

            item.addEventListener('click', function(e) {
                e.preventDefault();
                let video = this.closest('.video-wrapper');

                if(video.classList.contains('is-paused')) {
                    video.classList.remove('is-paused');
                } else {
                    video.classList.add('is-paused');
                }
            });
        })
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {    
        if (links[i].hostname !== window.location.hostname) {
             links[i].target = "_blank";        links[i].rel = "noreferrer noopener";
        }
    }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();